<template>
    <base-layout
        content_class="is-paddingless"
        v-if="detail.data.id"
        :theme="detail.data.theme"
        :show_sidebar="show_sidebars"
        :show_middle_sidebar="show_sidebars">

        <template slot="sidebar">
            <space-sidebar :space="detail.data" class="sidebar-content hide-scroll-bar"/>
        </template>

        <template slot="middle-sidebar">
            <tree-sidebar
                v-if="$route.query.topic || $route.query.private !== undefined"
                :space="detail.data"/>

            <tag-list v-else-if="$route.query.tags_list !== undefined" :space="detail.data"/>
            <note-list v-else :space="detail.data"/>
        </template>

        <note-details
            @toggle_sidebars="toggle_sidebars"
            :show_sidebars="show_sidebars"
            :space="detail.data" />
    </base-layout>

    <h1 v-else class="loader-container has-text-centered">
        <span class="loader is-inline-flex"></span>
    </h1>
</template>

<script>
import { mapState } from 'vuex';
import SpaceSidebar from '../components/space/SpaceSidebar.vue';
import BaseLayout from '../components/layouts/BaseLayout.vue';
import TreeSidebar from '../components/topic/TreeSidebar.vue';
import NoteDetails from '../components/note/NoteDetails.vue';
import NoteList from '../components/note/NoteList.vue';
import TagList from '../components/tag/TagList.vue';
import { set_title } from '../utils/helpers';


export default {
    name: 'SpacesContent',
    components: {
        TagList, NoteList, TreeSidebar, SpaceSidebar, NoteDetails, BaseLayout,
    },
    data() {
        return { show_sidebars: true };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.$store.commit('spaces/set_last_page', {
                    space_id: this.$route.params.space,
                    url: this.$route.fullPath,
                });
            },
        },
    },
    computed: mapState('spaces', ['detail']),
    methods: {
        toggle_sidebars(show) {
            this.show_sidebars = show;
        },
    },
    async created() {
        await this.$store.dispatch('spaces/detail', { space_id: this.$route.params.space });
        set_title(this.detail.data.name);
    },
    destroyed() {
        this.$store.commit('spaces/space_detail_clear');
    },
};
</script>

<style scoped>
    .loader-container {font-size: 8em; margin: 5rem}
</style>
